import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
     ganttTypeLists: []
};
const getters = {
    ganttType: state => state.ganttTypeLists

};

const mutations = {
    CONTACT_TYPE_INFO(state, data) {
        state.ganttTypeLists = data
    }
};

const actions = {
    ganttType(context) {
        axiosGet(`crm/gantt/types`).then((response) => {
            context.commit('CONTACT_TYPE_INFO', response.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
